import React from 'react';
import classname from '@search/classname/src';

import './RegionSelector2Button.css';

const cn = classname.bind(null, 'RegionSelector2Button');

interface RegionSelector2ButtonProps {
    dataTest?: string;
    after?: React.ReactNode;
    onClick?: () => void;
}

export const RegionSelector2Button: React.FC<RegionSelector2ButtonProps> = ({
    dataTest, onClick, children, after
}) => {
    return (
        <button
            className={cn()}
            data-test={dataTest}
            onClick={onClick}
        >
            <span>{children}</span>
            {after ? (<span className={cn('after')}>{after}</span>) : null}
        </button>
    );
};
